import { css, FlattenSimpleInterpolation } from 'styled-components';
import { pxToRem } from 'utils/convert';
import { CHART_SIZES } from '../types';

export const SIZE_STYLES: Record<CHART_SIZES, FlattenSimpleInterpolation> = {
  [CHART_SIZES.SMALL]: css({
    height: pxToRem(16),
    width: '100%',
  }),
  [CHART_SIZES.MEDIUM]: css({
    height: pxToRem(24),
    width: '100%',
  }),
  [CHART_SIZES.LARGE]: css({
    height: pxToRem(45),
    width: '100%',
  }),
};
